import { render } from "./DashboardModeSwitch.vue?vue&type=template&id=42ec4660&scoped=true"
import script from "./DashboardModeSwitch.vue?vue&type=script&lang=js"
export * from "./DashboardModeSwitch.vue?vue&type=script&lang=js"

import "./DashboardModeSwitch.vue?vue&type=style&index=0&id=42ec4660&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ec4660"]])

export default __exports__